// import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_MEASURE_ID;

// export const initGA = () => {
//     ReactGA.initialize(GA_MEASUREMENT_ID);
// };

// export const logPageView = () => {
//     ReactGA.send({
//         hitType: 'pageview',
//         page: window.location.pathname,
//     });
// };

// export const logEvent = (category, action, label) => {
//     ReactGA.event({
//         category,
//         action,
//         label,
//     });
// };

export const initGA = () => {
    // Since gtag is already initialized in index.html,
    // we just need to ensure it's available
    if (!window.gtag) {
        console.warn('Google Analytics not initialized properly');
        return;
    }
};

export const logPageView = (path) => {
    if (window.gtag) {
        window.gtag('config', GA_MEASUREMENT_ID, {
            page_path: path || window.location.pathname,
        });
    }
};

// Optional: Add custom event tracking if needed
export const logEvent = (category, action, label) => {
    if (window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
        });
    }
};
